import { defineMessages } from 'react-intl';

export default defineMessages({
    memberCentreEnrollment: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDEDetailsTable.Member Centre Enrollment',
        defaultMessage: 'Member Centre Enrollment',
    },
    namedInsured: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDEDetailsTable.Named Insured',
        defaultMessage: 'Named Insured',
    },
    enrollmentStatus: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDEDetailsTable.Enrollment Status',
        defaultMessage: 'Enrollment Status',
    },
    email: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDEDetailsTable.Email',
        defaultMessage: 'Email',
    },
    sendInviteButton: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDEDetailsTable.Send Invite',
        defaultMessage: 'Send Invite',
    },
    enrolled: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDEDetailsTable.Enrolled',
        defaultMessage: 'Enrolled',
    },
    notEnrolled: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDEDetailsTable.Not Enrolled',
        defaultMessage: 'Not Enrolled',
    },
    inviteSent: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDEDetailsTable.Invite Sent',
        defaultMessage: 'Invite Sent',
    },
    unavailable: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicySummary.WMICMDEDetailsTable.WMICMDEDetailsTable.Unavailable',
        defaultMessage: 'Unavailable',
    },
});
